import { Decoration, WidgetType } from "@codemirror/view";
import type { EditorState } from "@codemirror/state";
import type { LivePreviewCursor } from "./cursor";
import type { Tree } from "@lezer/common";

interface DecorationEntry {
  from: number;
  to: number;
  decoration: Decoration;
}

class HorizontalRuleWidget extends WidgetType {
  toDOM(): HTMLElement {
    const hr = document.createElement("hr");
    hr.className = "cm-md-hr";
    return hr;
  }

  eq(): boolean {
    return true;
  }
}

const hrWidget = new HorizontalRuleWidget();

/**
 * Build decorations for horizontal rules (---, ***, ___).
 *
 * When the cursor is NOT on the rule's line, the raw markdown text is
 * replaced with a styled <hr> widget. When the cursor IS on the line,
 * the raw text is shown for editing.
 */
export function buildHorizontalRuleDecorations(
  state: EditorState,
  tree: Tree,
  range: { from: number; to: number },
  cursor: LivePreviewCursor,
  decorations: DecorationEntry[],
): void {
  const cursorLine = cursor.cursorLine;

  tree.iterate({
    from: range.from,
    to: range.to,
    enter(node) {
      if (node.name !== "HorizontalRule") return;

      const ruleLine = state.doc.lineAt(node.from).number;

      // If cursor is on this line, show raw markdown for editing
      if (cursorLine === ruleLine) return;

      decorations.push({
        from: node.from,
        to: node.to,
        decoration: Decoration.replace({ widget: hrWidget }),
      });
    },
  });
}
